import { render, staticRenderFns } from "./DbLaunch.vue?vue&type=template&id=d8407342&"
import script from "./DbLaunch.vue?vue&type=script&lang=js&"
export * from "./DbLaunch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8407342')) {
      api.createRecord('d8407342', component.options)
    } else {
      api.reload('d8407342', component.options)
    }
    module.hot.accept("./DbLaunch.vue?vue&type=template&id=d8407342&", function () {
      api.rerender('d8407342', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/DbLaunch.vue"
export default component.exports